import { Col } from "react-bootstrap";
import PraisePerson from "./PraisePerson";
import "./PraisePersonsList.css";

function PraisePersonsList({ praises, language }) {
  return (
    <Col className="praise-person-list">
      {praises.map((element) => (
        <PraisePerson
          key={element.userId}
          id={element.userId}
          userName={element.userName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          count={element.count}
          language={language}
        />
      ))}
    </Col>
  );
}

export default PraisePersonsList;
